import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';
import ChartUserByCountry from '../components/ChartUserByCountry';
import CustomizedTreeView from '../components/CustomizedTreeView';
import CustomizedDataGrid from '../components/CustomizedDataGrid';
import HighlightedCard from '../components/HighlightedCard';
import PageViewsBarChart from '../components/PageViewsBarChart';
import SessionsChart from '../components/SessionsChart';
import StatCard from '../components/StatCard';
import MainMap from '../components/MainMap';
import ChartAssetsByType from '../components/ChartAssetsByType';
import { Button } from '@mui/material';
import AboutMap from '../components/AboutMap';

export default function About() {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        About
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, md: 6, lg: 6, xl: 4 }}>
          <Stack gap={2}>
            <Box sx={{ overflow: 'hidden' }}>
              <Box component="img" src="/assets/MILLET-Solid.svg" sx={{ float: 'left', width: 150, height: 150, margin: '0 1rem 0 0', borderRadius: '5%', objectFit: 'cover' }} />
              <Typography sx={{ textWrapStyle: 'balance' }}><b>MILLET Mobility</b>, a subsidiary of Indigrid Technology, delivers an advanced Battery Pack Analytics Dashboard designed to revolutionize your battery management. Our state-of-the-art platform offers comprehensive insights, allowing you to dive deep into data and make informed decisions about your battery packs. With real-time monitoring, you can stay updated with live status and performance metrics to ensure your batteries are always in optimal condition. Performance analysis helps you track and analyze historical data to identify trends and predict future maintenance needs.
                Our user-friendly interfaces allow for effortless navigation through intuitive dashboards and visualizations. Customizable alerts enable you to set up personalized notifications on critical parameters and potential issues, ensuring you are always in control. Seamless integration capabilities allow our dashboard to fit easily within your existing systems, creating a unified and efficient workflow.<br />
                Empower your operations with MILLET Mobility's innovative solutions and take control of your battery fleet with confidence and ease.
              </Typography>
            </Box>
            <br />
            <Box sx={{ overflow: 'hidden' }}>
              <Box component="img" src="/assets/IGT.png" sx={{ float: 'left', width: 150, margin: '0 1rem 0 0' }} />
              <Typography sx={{ textWrapStyle: 'balance' }}><b>Indigrid Technology</b> is a dynamic and forward-thinking company dedicated to revolutionizing electric mobility in India. As a passionate team, we are committed to providing cutting-edge solutions that accelerate the adoption of electric vehicles. From advanced battery packs to robust charging infrastructure, we strive to deliver reliable, efficient, and sustainable solutions that cater to the evolving needs of our customers. With a focus on customer satisfaction and a commitment to corporate responsibility, Indigrid is driving the transition towards a greener and more sustainable future.</Typography>
            </Box>
            <Button variant='outlined' href='https://www.indigridtechnology.com/'>Explore other products and services</Button>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6, lg: 6, xl: 8 }} sx={{ overflow: 'hidden', borderRadius: '8px', border: '1px solid var(--template-palette-divider)', height: { xs: '400px', md: 'unset' } }}>
          <AboutMap />
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
